import { useTranslation } from 'react-i18next'

import styled from 'styled-components'
import { mediaMax } from 'styles/media'
import ButtonLink from 'components/display/ButtonLink'
import { HeadingXxl, ParagraphSm } from 'components/display/Typography'

type Alignments = 'flex-start' | 'center'

interface HelpSectionProps {
  alignment: Alignments
  link: string
}

const Container = styled.div<{ alignment: Alignments }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ alignment }) => alignment};
  align-items: ${({ alignment }) => alignment};
  margin-top: 20px;

  ${ButtonLink} {
    margin-top: 10px;
  }

  ${mediaMax.md`
    margin-top: 0;
    justify-content: flex-start;
    align-items: flex-start;
  `}
`

const HelpSection = ({ alignment, link }: HelpSectionProps) => {
  const [t] = useTranslation()
  return (
    <Container alignment={alignment}>
      <HeadingXxl centered>Still need help?</HeadingXxl>
      <ParagraphSm centered={alignment === 'center'}>
        Our {t('helpCenter.name')} might have the information you’re after.
      </ParagraphSm>

      <ButtonLink
        href={link}
        target="_blank"
        inline
        compact
        ghost
        uppercase={false}
      >
        Visit {t('helpCenter.name')}
      </ButtonLink>
    </Container>
  )
}

export default HelpSection
